import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const KnowledgeHub = forwardRef<SVGSVGElement, SvgIconProps>(
  function KnowledgeHub({ fill = '#3C3838', ...props }, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path
          d="M12 22.5C10.8 21.3667 9.425 20.5 7.875 19.9C6.325 19.3 4.7 19 3 19V8C4.68333 8 6.3 8.30417 7.85 8.9125C9.4 9.52083 10.7833 10.4 12 11.55C13.2167 10.4 14.6 9.52083 16.15 8.9125C17.7 8.30417 19.3167 8 21 8V19C19.2833 19 17.6542 19.3 16.1125 19.9C14.5708 20.5 13.2 21.3667 12 22.5ZM12 9C10.9 9 9.95833 8.60833 9.175 7.825C8.39167 7.04167 8 6.1 8 5C8 3.9 8.39167 2.95833 9.175 2.175C9.95833 1.39167 10.9 1 12 1C13.1 1 14.0417 1.39167 14.825 2.175C15.6083 2.95833 16 3.9 16 5C16 6.1 15.6083 7.04167 14.825 7.825C14.0417 8.60833 13.1 9 12 9Z"
          fill={fill}
        />
      </SvgIcon>
    )
  },
)

export default KnowledgeHub
